// extracted by mini-css-extract-plugin
module.exports = {"trigger":"dropdown_trigger__dAeyh"};